(function() {
  'use strict';

  function getTomorrowMountainTime() {
    var now = new Date();
    var mt = new Date(now.toLocaleString('en-US', { timeZone: 'America/Denver' }));
    mt.setDate(mt.getDate() + 1);
    var year = mt.getFullYear();
    var month = String(mt.getMonth() + 1).padStart(2, '0');
    var day = String(mt.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  function setupAddons() {
    var noneBox = document.getElementById('ct-addon-none');
    var itemBoxes = document.querySelectorAll('[data-addon="item"]');
    var hiddenInput = document.getElementById('ct-addons-choice');
    if (!noneBox || !hiddenInput) return;

    function updateHidden() {
      if (noneBox.checked) {
        hiddenInput.value = 'None';
        return;
      }
      var selected = [];
      itemBoxes.forEach(function(cb) {
        if (cb.checked) selected.push(cb.closest('label').querySelector('span').textContent.trim());
      });
      hiddenInput.value = selected.length ? selected.join(', ') : '';
    }

    noneBox.addEventListener('change', function() {
      if (noneBox.checked) {
        itemBoxes.forEach(function(cb) { cb.checked = false; });
      }
      updateHidden();
    });

    itemBoxes.forEach(function(cb) {
      cb.addEventListener('change', function() {
        if (cb.checked) {
          noneBox.checked = false;
        }
        updateHidden();
      });
    });
  }

  function validate() {
    var location = document.querySelector('input[name="properties[Pickup Location]"]:checked');
    var date = document.getElementById('ct-pickup-date');
    var time = document.getElementById('ct-pickup-time');
    var coffeeType = document.querySelector('input[name="properties[Coffee Type]"]:checked');
    var addonsChoice = document.getElementById('ct-addons-choice');

    if (!location) {
      alert('Please select a pickup location.');
      return false;
    }
    if (!date || !date.value) {
      alert('Please select a pickup date.');
      return false;
    }
    var tomorrow = getTomorrowMountainTime();
    if (date.value < tomorrow) {
      alert('Pickup date must be at least one day from now.');
      return false;
    }
    if (!time || !time.value) {
      alert('Please select a pickup time.');
      return false;
    }
    if (!coffeeType) {
      alert('Please select regular or decaf coffee.');
      return false;
    }
    if (!addonsChoice || !addonsChoice.value) {
      alert('Please select your add-ons, or choose "None".');
      return false;
    }
    return true;
  }

  function init() {
    var dateInput = document.getElementById('ct-pickup-date');
    if (!dateInput) return;

    dateInput.setAttribute('min', getTomorrowMountainTime());
    setupAddons();

    // Intercept form submit in capture phase (runs before the custom element handler)
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (form) {
      form.addEventListener('submit', function(e) {
        if (!validate()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          // Reset the add-to-cart button loading state
          var btn = form.querySelector('product-to-cart');
          if (btn) {
            var inner = btn.querySelector('[data-element="to-cart-button"]');
            if (inner) inner.classList.remove('!loading');
          }
        }
      }, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
